import { Dispatch } from '@reduxjs/toolkit';
import { injectReducer } from 'ducks/configureStore';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ducks';
import { Feature, RenderLocation, RendersComponent, ShouldReset } from 'features/Feature';
import AdjustableClothRailInformationSheet from '../sheets/AdjustableClothRailInformationSheet/AdjustableClothRailInformationSheet';

export type AdjustableClothRailState = {
  adjustableClothRailInformationSheet: boolean;
};

const initialState: AdjustableClothRailState = {
  adjustableClothRailInformationSheet: false
};

type ExtendedRootState = RootState & {
  adjustableClothRail: AdjustableClothRailState;
};

const AdjustableClothRailSlice = createSlice({
  name: 'AdjustableClothRailSlice',
  initialState,
  reducers: {
    setAdjustableClothRailInformationSheet(state, action: PayloadAction<boolean>) {
      state.adjustableClothRailInformationSheet = action.payload;
    }
  }
});

export const isAdjustableClothRailInformationSheetVisible = (state: ExtendedRootState) =>
  state.adjustableClothRail.adjustableClothRailInformationSheet;

export const { setAdjustableClothRailInformationSheet } = AdjustableClothRailSlice.actions;

export class AdjustableClothRailFeature extends Feature implements RendersComponent, ShouldReset {
  protected init(): void {
    injectReducer<AdjustableClothRailState>(
      'adjustableClothRail',
      AdjustableClothRailSlice.reducer
    );
  }

  render(location: RenderLocation) {
    if (location !== RenderLocation.Root) return;
    return AdjustableClothRailInformationSheet;
  }

  reset(dispatch: Dispatch) {
    dispatch(setAdjustableClothRailInformationSheet(false));
  }
}
